// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uJYaPBToZwRLCBF2Orws {
  margin-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.FYUZDALv4Q5pNj0XgTQ0 {
  gap: 1rem;
}

.MLZP9cizb7rPxcL0j4IQ {
  gap: 0.5rem;
}

.zDGDO16VVKmWcOk6H6SG {
  gap: 0.5rem;
  max-width: -webkit-calc(100% - 7.25rem);
  max-width: -moz-calc(100% - 7.25rem);
  max-width: calc(100% - 7.25rem);
}

.UxBAxYhhP1irYJvpEzEC {
  color: var(--gray-500);
  padding: 0.4375rem 0.75rem;
  background-color: var(--gray-100);
  -moz-border-radius: 3rem;
       border-radius: 3rem;

  & > svg {
    width: 0.75rem;
  }
}

.Mw4IjY22AeoJAbVo7YV3 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
}

.y5C4tavfOZw3QIt7ek21 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--gray-600);
  line-height: 1.5;
}

.fF7bRzDLZC_mDI30zcdO {
  width: 6.25rem;
  height: 6.25rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;

  & > img {
    aspect-ratio: 1/1;
    -o-object-fit: fill;
       object-fit: fill;
  }
}

.uXQzVBSHkdct0sS8lLal {
  right: 0.25rem;
  bottom: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CommunityDetails/Posts/live/components/liveHighlightItem/liveHighlightItem.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uCAA+B;EAA/B,oCAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;EACjC,wBAAmB;OAAnB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAc;UAAd,cAAc;;EAEd;IACE,iBAAiB;IACjB,mBAAgB;OAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".box {\n  margin-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.textBox {\n  gap: 1rem;\n}\n\n.headerBox {\n  gap: 0.5rem;\n}\n\n.text {\n  gap: 0.5rem;\n  max-width: calc(100% - 7.25rem);\n}\n\n.pin {\n  color: var(--gray-500);\n  padding: 0.4375rem 0.75rem;\n  background-color: var(--gray-100);\n  border-radius: 3rem;\n\n  & > svg {\n    width: 0.75rem;\n  }\n}\n\n.title {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  line-height: 1.2;\n}\n\n.desc {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: var(--gray-600);\n  line-height: 1.5;\n}\n\n.imgBox {\n  width: 6.25rem;\n  height: 6.25rem;\n  flex-shrink: 0;\n\n  & > img {\n    aspect-ratio: 1/1;\n    object-fit: fill;\n  }\n}\n\n.badge {\n  right: 0.25rem;\n  bottom: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var box = `uJYaPBToZwRLCBF2Orws`;
export var textBox = `FYUZDALv4Q5pNj0XgTQ0`;
export var headerBox = `MLZP9cizb7rPxcL0j4IQ`;
export var text = `zDGDO16VVKmWcOk6H6SG`;
export var pin = `UxBAxYhhP1irYJvpEzEC`;
export var title = `Mw4IjY22AeoJAbVo7YV3`;
export var desc = `y5C4tavfOZw3QIt7ek21`;
export var imgBox = `fF7bRzDLZC_mDI30zcdO`;
export var badge = `uXQzVBSHkdct0sS8lLal`;
export default ___CSS_LOADER_EXPORT___;
